import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./App.css";
import "./styles/Utilities.css";
import "@splidejs/react-splide/css";
import "rsuite/dist/rsuite-no-reset.min.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { Home } from "./pages/Home";
import { IntlProvider } from "react-intl";
import { useEffect, useState } from "react";
import idLocale from "./locales/id.json";
import enLocale from "./locales/en.json";
import PostsProvider from "./contexts/PostsProvider";
import { Products } from "./pages/Products";
import { Bio } from "./pages/Bio";
import { Blog } from "./pages/Blog";
import { BlogDetail } from "./pages/BlogDetail";
import { HelmetProvider } from "react-helmet-async";
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-NTJ5WMSP'
};

TagManager.initialize(tagManagerArgs);

function FallbackRedirect() {
  return <Navigate to="/" replace />;
}

function App() {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "id");

  const allMessages: { [key: string]: { [key: string]: string } } = {
    id: idLocale,
    en: enLocale,
  };

  const messages = allMessages[locale];

  useEffect(() => {
    if (!localStorage.getItem("locale")) {
      localStorage.setItem("locale", "id");
    }
  }, []);

  return (
    <PostsProvider>
      <div className="App">
        <IntlProvider locale={locale} messages={messages}>
          <BrowserRouter>
            <Routes>
              <Route path="/">
                <Route index element={<Home setLocale={setLocale} />} />
                <Route
                  path="product/wooblazz-ads"
                  element={<Products setLocale={setLocale} type={"ads"} />}
                />
                <Route
                  path="product/wooblazz-chat"
                  element={<Products setLocale={setLocale} type={"chat"} />}
                />
                <Route
                  path="product/wooblazz-crm"
                  element={<Products setLocale={setLocale} type={"crm"} />}
                />
                <Route
                  path="product/wooblazz-ai-agent"
                  element={<Products setLocale={setLocale} type={"ai-agent"} />}
                />
                <Route path="bio" element={<Bio />} />
                <Route
                  path="/blog"
                  element={
                    <HelmetProvider>
                      <Blog locale={locale} setLocale={setLocale} />
                    </HelmetProvider>
                  }
                />
                <Route
                  path="/blog/category/:categorySlug"
                  element={
                    <HelmetProvider>
                      <Blog locale={locale} setLocale={setLocale} />
                    </HelmetProvider>
                  }
                />
                <Route
                  path="/blog/:id/:slugTitle"
                  element={
                    <HelmetProvider>
                      <BlogDetail locale={locale} setLocale={setLocale} />
                    </HelmetProvider>
                  }
                />
                <Route path="*" element={<FallbackRedirect />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </IntlProvider>
      </div>
    </PostsProvider>
  );
}

export default App;
